export default __webpack_public_path__ + "static/media/dependant.15c7e985.svg";